// frontend/admin-portal/src/routes/domains/procurementRoutes.jsx
import React from "react";
import { Route } from "react-router-dom";
import { PermissionRoute } from "@fiberhome/shared-ui";

import Requisitions from "../../pages/Requisitions";
import RequisitionDetail from "../../pages/RequisitionDetail";
import RfqDetail from "../../pages/RfqDetail";
import RfqComparison from "../../pages/RfqComparison";
import PurchaseOrders from "../../pages/PurchaseOrders";
import ImportPurchaseOrder from "../../pages/ImportPurchaseOrder";
import PurchaseOrderDetail from "../../pages/PurchaseOrderDetail";
import GoodsReceipts from "../../pages/GoodsReceipts";

export default function ProcurementRoutes() {
  return (
    <>
      {/* Requisitions & RFQs */}
      <Route element={<PermissionRoute permission="procurement.read" />}>
        <Route path="requisitions" element={<Requisitions />} />
        <Route path="requisitions/:id" element={<RequisitionDetail />} />
        <Route path="requisitions/:id/comparison" element={<RfqComparison />} />
        <Route path="rfqs/:id" element={<RfqDetail />} />
      </Route>

      {/* Purchase Orders */}
      <Route element={<PermissionRoute permission="purchase_orders.read" />}>
        <Route path="purchase-orders" element={<PurchaseOrders />} />
        {/* /purchase-orders/import MUST be declared BEFORE /:id */}
        <Route
          path="purchase-orders/import"
          element={<ImportPurchaseOrder />}
        />
        <Route path="purchase-orders/:id" element={<PurchaseOrderDetail />} />
      </Route>

      {/* Goods Receipts */}
      <Route element={<PermissionRoute permission="goods_receipts.read" />}>
        <Route path="goods-receipts" element={<GoodsReceipts />} />
      </Route>
    </>
  );
}
